import { type FC, useContext } from "react";
import { createBorderStyles } from "../../Forms/DragDrop/BorderSettingsDialog";
import { DragDropComponentErrorContext } from "../../Forms/DragDrop/DragDropComponent";
import { DragDropDataContext } from "../../Forms/DragDrop/DragDropRenderer";
import { type ComponentOptions } from "../../Forms/DragDrop/DragDropTypes";
import { createStyleFromPadding } from "../../Forms/PaddingInput";

export const ReceiptEFTPOSComponent: FC<ComponentOptions> = ({ style }) => {
    const { eftpos } = useContext(DragDropDataContext);

    const error = useContext(DragDropComponentErrorContext);

    if(typeof eftpos !== "string") {
        return error;
    }

    const { textAlign, border, padding } = style;

    let marginLeft = "0";
    let marginRight = "auto";

    if(textAlign === "center") {
        marginLeft = "auto";
    } else if(textAlign === "right") {
        marginLeft = "auto";
        marginRight = "0";
    }

    return (
        <div
            className="eftpos-receipt"
            style={{
                whiteSpace: "pre",
                fontFamily: "monospace",
                ...(border ? createBorderStyles(border) : {}),
                ...(padding ? createStyleFromPadding(padding) : {}),
            }}
        >
            <div
                style={{
                    width: "fit-content",
                    marginRight,
                    marginLeft,
                }}
            >
                {eftpos}
            </div>
        </div>
    );
};
